/* Product Card Gallery — arrows + touch swipe + dot sync */
(function() {
  if (window._jpGalleryInit) return;
  window._jpGalleryInit = true;

  function switchImage(card, nextIndex) {
    var media = card.querySelector('.card__media');
    var allImages = Array.from(card.querySelectorAll('.card__image'));
    if (allImages.length <= 1) return;
    nextIndex = ((nextIndex % allImages.length) + allImages.length) % allImages.length;
    allImages.forEach(function(img, idx) {
      img.classList.remove('jp-active', 'jp-hidden');
      img.classList.add(idx === nextIndex ? 'jp-active' : 'jp-hidden');
    });
    media.setAttribute('data-current-index', nextIndex);
    // Sync dots
    var dots = card.querySelectorAll('.gallery-dot');
    dots.forEach(function(dot, idx) {
      dot.classList.toggle('gallery-dot--active', idx === nextIndex);
    });
  }

  // Arrow click handler (capture phase — before anchor)
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.gallery-arrow');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var card = btn.closest('.product-card-gallery');
    if (!card) return;
    var media = card.querySelector('.card__media');
    var currentIndex = parseInt(media.getAttribute('data-current-index') || '0');
    var allImages = card.querySelectorAll('.card__image');
    var nextIndex = btn.classList.contains('prev')
      ? (currentIndex - 1 + allImages.length) % allImages.length
      : (currentIndex + 1) % allImages.length;
    switchImage(card, nextIndex);
  }, true);

  // Dot click handler
  document.addEventListener('click', function(e) {
    var dot = e.target.closest('.gallery-dot');
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var card = dot.closest('.product-card-gallery');
    if (!card) return;
    var idx = parseInt(dot.getAttribute('data-dot-index') || '0');
    switchImage(card, idx);
  }, true);

  // Touch swipe handler
  var touchStartX = 0;
  var touchCard = null;
  document.addEventListener('touchstart', function(e) {
    var media = e.target.closest('.card__media');
    if (!media) return;
    touchCard = media.closest('.product-card-gallery');
    touchStartX = e.touches[0].clientX;
  }, { passive: true });

  document.addEventListener('touchend', function(e) {
    if (!touchCard) return;
    var touchEndX = e.changedTouches[0].clientX;
    var diff = touchStartX - touchEndX;
    if (Math.abs(diff) > 40) {
      var media = touchCard.querySelector('.card__media');
      var currentIndex = parseInt(media.getAttribute('data-current-index') || '0');
      var allImages = touchCard.querySelectorAll('.card__image');
      var nextIndex = diff > 0
        ? (currentIndex + 1) % allImages.length  // swipe left = next
        : (currentIndex - 1 + allImages.length) % allImages.length;  // swipe right = prev
      switchImage(touchCard, nextIndex);
      // Prevent link navigation on swipe
      e.preventDefault();
    }
    touchCard = null;
  }, { passive: false });
})();
